module.exports = __webpack_public_path__ + "static/media/0025.cf5562af.jpg";